<template>
  <ValidationObserver ref="form">
    <form :id="fieldId" :style="styles">
      <div class="row justify-content-center">
        <div class="formWrapper">
          <div class="col-12">
            <div class="row">
              <div
                class="fields col-12"
                :class="{ 'col-lg-6': !!extraFields.length }"
              >
                <template v-for="field in fields">
                  <componentRenderer
                    :field="field"
                    v-on:component-updated="updated"
                    v-bind:key="field.id"
                    v-if="field.fieldType !== 'checkbox'"
                  />
                </template>
              </div>
              <div v-if="extraFields.length" class="fields col-12 col-lg-6">
                <template v-for="field in extraFields">
                  <componentRenderer
                    :field="field"
                    v-on:component-updated="updated"
                    v-bind:key="field.id"
                    v-if="field.fieldType !== 'checkbox'"
                  />
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <div class="checkboxes">
          <template v-for="field in checkboxFields">
            <componentRenderer
              :field="field"
              v-on:component-updated="updated"
              v-bind:key="field.id"
            />
          </template>
        </div>
      </div>
    </form>
    <mfa v-if="multiFactorAuth" :successAction="successAction" />
  </ValidationObserver>
</template>
<script>
import componentRenderer from "@/components/component-renderer";
import mfa from "@/components/renderers/mfa-modal.vue"
import { mapGetters } from "vuex";

export default {
  name: "form-component",
  components: { componentRenderer, mfa },
  props: {
    fieldId: String,
    requires: Array,
    successAction: {
      type: Object,
      default: () => null
    },
    endpoint: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    extraFields: {
      type: Array,
      required: false,
      default: () => []
    },
    styles: {
      type: Object,
      required: false,
      default: () => {}
    },
    keepInState: Array,
    gReCaptcha3: {
      type: Boolean,
      default: false
    },
    multiFactorAuth: {
      type: Boolean,
      default: false
    },
    checkFlaggedIP: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["customerToken", "campaignId", "receiptToken"]),
    checkboxFields() {
      return [...this.fields, ...this.extraFields].filter(
        (field) => field.fieldType === "checkbox"
      );
    }
  },
  methods: {
    clicked() {
      // console.log("FORM CLICKED", this);
    },
    clear() {
      this.fields.forEach((field) => {
        if (field.fieldType === "text-input") {
          field.properties.text = "";
        } else if (field.fieldType === "select-input") {
          field.properties.text = "";
        } else if (field.fieldType === "radio-input") {
          field.properties.selectedValue = "";
        } else if (field.fieldType === "checkbox") {
          field.properties.checked = "";
        } else if (field.fieldType === "date-input") {
          field.properties.value = "";
        }
      });
    },
    getFormData(formId, triggers) {
      // const form=document.forms[formId]
      // console.log("form",this.fieldId,this)
      // console.log("Locale", this.locale);
      if (this.fieldId === formId) {
        // console.log("inside getFormData", this, formId, this.$refs.form);

        const formData = {};
        const endpoint = this.endpoint;
        if (this.locale) {
          formData.lang = this.locale;
        }
        formData.customerToken = this.customerToken;
        formData.campaignId = this.campaignId;
        formData.receiptToken = this.receiptToken;
        [...this.fields, ...this.extraFields].forEach((field) => {
          if (field.fieldType === "text-input") {
            const name = field.properties.name;
            const value = field.properties.text;
            formData[name] = value;
          } else if (field.fieldType === "select-input") {
            const name = field.properties.name;
            const value = field.properties.text;
            formData[name] = value;
          } else if (field.fieldType === "select-input-county") {
            const name = field.properties.name;
            const value = field.properties.text;
            formData[name] = value;
          } else if (field.fieldType === "select-input-city") {
            const name = field.properties.name;
            const value = field.properties.text;
            formData[name] = value;
          } else if (field.fieldType === "radio-input") {
            const name = field.properties.name;
            const value = field.properties.selectedValue;
            formData[name] = value;
          } else if (field.fieldType === "checkbox") {
            const name = field.properties.name;
            const value = field.properties.checked;
            formData[name] = value;
          } else if (field.fieldType === "date-input") {
            const name = field.properties.name;
            const value = field.properties.value;
            formData[name] = value;
          } else if (field.fieldType === "empty-bucket") {
            field.properties.fields.forEach((field) => {
              if (field.fieldType === "text-input") {
                const name = field.properties.name;
                const value = field.properties.text;
                formData[name] = value;
              } else if (field.fieldType === "select-input") {
                const name = field.properties.name;
                const value = field.properties.text;
                formData[name] = value;
              } else if (field.fieldType === "radio-input") {
                const name = field.properties.name;
                const value = field.properties.selectedValue;
                formData[name] = value;
              } else if (field.fieldType === "select-input-county") {
                const name = field.properties.name;
                const value = field.properties.text;
                formData[name] = value;
              } else if (field.fieldType === "select-input-city") {
                const name = field.properties.name;
                const value = field.properties.text;
                formData[name] = value;
              } else if (field.fieldType === "checkbox") {
                const name = field.properties.name;
                const value = field.properties.checked;
                formData[name] = value;
              } else if (field.fieldType === "date-input") {
                const name = field.properties.name;
                const value = field.properties.value;
                formData[name] = value;
              }
            });
          }else if (field.fieldType === "text-area"){
              const name = field.properties.name;
              const value = field.properties.text;
              formData[name] = value;
          }
        });
        this.$refs.form.validate().then((isValid) => {
          if (isValid) {
            // console.log("SENDING FORM>>", formData);
            const presistentFormFields = {};
            if (this.keepInState) {
              this.keepInState.forEach((field) => {
                presistentFormFields[field] = this.$store.state.formData[field];
              });
            }
            this.$store.commit("setField", {
              field: "formData",
              value: { ...presistentFormFields, ...formData }
            });
            // this.$route.push('/78j8ji');
            if (this.gReCaptcha3) {
              window.grecaptcha.execute('6LczTHgpAAAAAO6R53bJvwsk7s46xy2Dl2Z9kW9O', { action: 'register' })
              .then((token) => {
                this.sendFormData(formData, endpoint, triggers, token, presistentFormFields)
              })
            } else this.sendFormData(formData, endpoint, triggers, '', presistentFormFields)
          } else {
            this.$eventHub.$emit("done-event-trigger", {
              parent: this,
              status: false
            });
          }
        });
      }
    },
    sendFormData(formData, endpoint, triggers, recaptchaToken, presistentFormFields) {
      this.$store
        .dispatch("sendFormData", { formData, endpoint, triggers, recaptchaToken })
        .then((r) => {
          if (r.response && this.successAction && this.multiFactorAuth && !r.referenceNumber) {
            this.$store.commit('setCustomerMobile', formData.mobile)
            this.$eventHub.$emit('startMFA-event')
            this.$eventHub.$emit("done-event-trigger", {
              parent: this,
              status: true
            });
          } else if (r.response && this.successAction) {
            const fn = this.successAction.fn;
            const params = this.successAction.params;
            this[fn](params, this);
            this.$eventHub.$emit("done-event-trigger", {
              parent: this,
              status: true
            });
          }
          this.$eventHub.$emit("done-event-trigger", {
            parent: this,
            status: false,
            message: r.message || "Unexpected Error",
            invalid_fields: r.invalid_fields || []
          });

          if (r.response) {
            // append response payload into formData
            this.$store.commit("setField", {
              field: "formData",
              value: {
                ...presistentFormFields,
                ...formData,
                ...r
              }
            });
          }
        })
        .catch((e) => {
          this.$eventHub.$emit("done-event-trigger", {
            parent: this,
            status: false
          });
        });
    },
    updated(field, properties) {
      let updatedField = this._.find(
        [...this.fields, ...this.extraFields],
        function (fld) {
          return fld.fieldId === field.fieldId;
        }
      );
      updatedField.properties = { ...updatedField.properties, ...properties };
      // let updatedField = __.findDeep(this.fields, fld => fld === field.fieldId);
      // console.log(
      //   "component renderer on updated::",
      //   field,
      //   "properties",
      //   properties,
      //   "FOUND",
      //   updatedField
      // );

      // TODO
      // some validation will go here
      // in case if all fields are valid we are happy to set truthy status
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: true
      });
    }
  },
  mounted() {
    // console.log("mountedForm", this);

    this.$eventHub.$on("getFormData-event", this.getFormData);
  },
  beforeMount () {
    // console.log(window.grecaptcha)
    if (this.gReCaptcha3 && !window.grecaptcha) {
      const recaptchaScript = document.createElement('script')
      recaptchaScript.src = "https://www.google.com/recaptcha/api.js?render=6LczTHgpAAAAAO6R53bJvwsk7s46xy2Dl2Z9kW9O"
      document.getElementsByTagName('head')[0].appendChild(recaptchaScript)
    }
  }
};
</script>
<style scoped lang="scss">
* {
  font-family: "Plus Jakarta Sans";
}

.formWrapper {
  width: 100%;
  @media (min-width: 767px) {
    background: #ffffff;
    box-shadow: 0px 16px 32px -3px #e2e8f9;
    border-radius: 16px;
    padding: 25px;
    //  max-width: 545px;
    max-width: var(--maxWidth);
    .fields {
      background: var(--backgroundColor);
      border-radius: 8px;
      padding: 30px;
    }
  }
  @media (max-width: 767px) {
    .fields {
      p {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
}

.checkboxes {
  label {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #0f2967;
  }
}
</style>
